import { useParams, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { ArrowLeft } from "lucide-react";
import { api } from "@/api";
import { C, STAGE_COLORS } from "@/theme";
import { stageLabel } from "@/pathway";
import { Card, LoadingState, EmptyState } from "@/ui";
import { RunDetails } from "@/shared";
import { PageHeader } from "@/components/AppShell";

export default function RunView() {
  const { id } = useParams();
  const navigate = useNavigate();
  const q = useQuery({ queryKey: ["runs"], queryFn: () => api.get("/runs") });
  const run = (q.data ?? []).find((r) => r.id === id);
  const stage = run?.stage ?? run?.run_type ?? "";
  const stageColor = STAGE_COLORS[stage] ?? C.brandPrimary;

  return (
    <div>
      <button onClick={() => navigate(-1)} style={{ color: C.muted }} className="flex items-center gap-1.5 text-sm font-semibold mb-3"><ArrowLeft size={16} />Back</button>
      <PageHeader title={run?.run_number ? `Run ${run.run_number}` : "Run"} subtitle={run?.rider_name} />
      {q.isLoading ? <LoadingState /> : !run ? <EmptyState title="Run not found" /> : (
        <div className="flex flex-col gap-4 max-w-2xl">
          <Card><div className="flex items-center gap-3"><span style={{ background: stageColor + "22", color: stageColor }} className="px-3 py-1.5 rounded-full text-sm font-extrabold">Run {run.run_number}</span><span style={{ color: C.onSurface }} className="text-lg font-extrabold">{stageLabel(stage)}</span></div><p style={{ color: C.muted }} className="text-[13px] mt-1.5 font-semibold">View only</p></Card>
          <Card><RunDetails run={run} /></Card>
        </div>
      )}
    </div>
  );
}
